module.exports = __webpack_public_path__ + "img/big_1_72.a49bbf63.png";